<template lang="pug">
#listar-monitoramento-agricola
    BaseHeader(
        :titulo='$t("mensagens.monitoramentoAgricola.baseHeader.titulo")',
        icon='el-icon-circle-plus-outline',
        :btnTexto='$t("mensagens.monitoramentoAgricola.baseHeader.botao")',
        :exibeBotao='true',
        @btnHeaderClicado='btnHeaderClicado'
    )

    .view-container-base-header
        .margin-top
            FiltrarMonitoramentoAgricola(
                :cultura='culturaSelecionada',
                @atualizar-filtro-avancado='atualizarFiltroAvancado',
                @remover-cultura-selecionada='removerCulturaSelecionada'
            )
        BlocoAlertaMonitoramentoAgricola
        BlocoCulturaMonitoramentoAgricola(
            :remover-cultura='removerCultura',
            @atualizar-filtro-avancado='atualizarFiltroAvancado'
        )
        .container-totalizadores
            h3 {{ $t('mensagens.monitoramentoAgricola.totalizadores.titulo') }}
            .totalizadores-lista
                BaseBlocoTotalizador(
                    :texto='$t("mensagens.monitoramentoAgricola.totalizadores.numeroTerritorios")',
                    :numero='totalizadores.qdeTerritorios'
                )
                    template(slot='icone')
                        i.lyra-icon.lyra-mapa
                BaseBlocoTotalizador(
                    :texto='$t("mensagens.monitoramentoAgricola.totalizadores.areaMonitorada")',
                    :numero='totalizadores.areaMonitorada'
                )
                    template(slot='icone')
                        i.lyra-icon.lyra-territorio-monitorado
                BaseBlocoTotalizador(
                    :texto='$t("mensagens.monitoramentoAgricola.totalizadores.areaPlantadaConfirmada")',
                    :numero='totalizadores.areaPlantadaConfirmada'
                )
                    template(slot='icone')
                        i.lyra-icon.lyra-quadro
                BaseBlocoTotalizador(
                    :texto='$t("mensagens.monitoramentoAgricola.totalizadores.produtividadeMedia")',
                    :numero='totalizadores.produtividadeMedia'
                )
                    template(slot='icone')
                        i.lyra-icon.lyra-grafico-2
                BaseBlocoTotalizador(
                    :texto='$t("mensagens.monitoramentoAgricola.totalizadores.producao")',
                    :numero='totalizadores.producao'
                )
                    template(slot='icone')
                        i.lyra-icon.lyra-folha
                BaseBlocoTotalizador(
                    :texto='$t("mensagens.monitoramentoAgricola.totalizadores.estimativaInicioColheita")',
                    :numero='totalizadores.estimativaInicioColheita'
                )
                    template(slot='icone')
                        i.lyra-icon.lyra-relogio

        .margin-top
            BlocoEvolucaoMonitoramentoAgricola(:filtros='filtros')
            ListaMonitoramentoAgricola(
                :filtros='filtros',
                @buscarTotalizadores='buscarTotalizadores'
            )
</template>

<script>
import BlocoEvolucaoMonitoramentoAgricola from '@/components/monitoramento/BlocoEvolucaoMonitoramentoAgricola';
import BaseHeader from '@/components/BaseHeader';
import BlocoCulturaMonitoramentoAgricola from '@/components/monitoramento/BlocoCulturaMonitoramentoAgricola';
import BaseBlocoTotalizador from '@/components/monitoramento/BaseBlocoTotalizador';
import BlocoAlertaMonitoramentoAgricola from '@/components/monitoramento/BlocoAlertaMonitoramentoAgricola';
import FiltrarTerritorioMonitoramento from '@/components/monitoramento/FiltrarTerritorioMonitoramento';
import ListaMonitoramentoAgricola from '@/components/monitoramento/ListaMonitoramentoAgricola';
import FiltrarMonitoramentoAgricola from '@/components/monitoramento/FiltrarMonitoramentoAgricola.vue';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'index',
    components: {
        BaseHeader,
        BlocoCulturaMonitoramentoAgricola,
        BaseBlocoTotalizador,
        BlocoAlertaMonitoramentoAgricola,
        FiltrarTerritorioMonitoramento,
        ListaMonitoramentoAgricola,
        FiltrarMonitoramentoAgricola,
        BlocoEvolucaoMonitoramentoAgricola
    },
    data() {
        return {
            filtros: {
                idCulturas: [],
                idSafras: [],
                possuiAlertas: null,
                idRepresentantes: [],
                idTerritorios: []
            },
            totalizadores: [],
            culturaSelecionada: '',
            removerCultura: {
                remover: false,
                id: null
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== 'MonitoramentoAgricolaImovel') {
            this.limparCulturaFiltrada();
            this.limparFiltroMonitoramento();
        }
        next(true);
    },

    watch: {
        filtros: function () {
            this.buscarTotalizadores();
        }
    },

    computed: {
        ...mapGetters(['filtroMonitoramento', 'culturaFiltrada'])
    },

    created() {
        if (this.filtroMonitoramento) {
            this.atualizarFiltroAvancado(
                this.filtroMonitoramento,
                this.culturaFiltrada
            );
        } else {
            this.buscarTotalizadores();
        }
    },

    methods: {
        ...mapActions(['limparCulturaFiltrada', 'limparFiltroMonitoramento']),

        btnHeaderClicado: function () {
            this.$router.push({ name: 'CadastrarMonitoramentoAgricola' });
        },
        removerCulturaSelecionada() {
            this.removerCultura = {
                remover: true,
                id: this.filtros.idCulturas[0]
            };
            this.limparCulturaFiltrada();
        },
        atualizarFiltroAvancado(filtros, cultura) {
            this.filtros = {
                ...this.filtros,
                ...filtros
            };
            this.culturaSelecionada = cultura;
        },

        buscarTotalizadores() {
            MonitoramentoAgricolaService.buscarTotalizadores(this.filtros)
                .then(({ data }) => {
                    setTimeout(() => {
                        this.totalizadores = data;
                    }, 500);
                })
                .catch(error => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.monitoramentoAgricola.erros.buscarTotalizadores'
                        )
                    });
                    throw error;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
#listar-monitoramento-agricola {
    .margin-top {
        margin-top: 15px;
    }

    .container-totalizadores {
        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
            font-weight: 500;
        }

        .totalizadores-lista {
            width: 100%;
            margin: 0 auto;
            display: grid;
            grid-template-columns: 33.33% 33.33% 33.33%;
        }

        .totalizadores-bloco {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
